import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Section } from "components/common";
import { Alert } from "components/bootstrap";
const StreamIlluminateProcessingSection = ({ stream }) => {
  const { t } = useTranslation("enterprise_data_lake");
  if (!stream.title.startsWith("Illuminate")) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Section, { title: t("illuminate.title") }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "default" }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "illuminate.description_1", components: { bold: /* @__PURE__ */ React.createElement("b", null) } }), /* @__PURE__ */ React.createElement("br", null), t("illuminate.description_2")));
};
export default StreamIlluminateProcessingSection;
